import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { Bento } from "@/components/Bento";
import { HowItWorks } from "@/components/HowItWorks";
import { Screenshots } from "@/components/Screenshots";
import { Community } from "@/components/Community";
import { Safety } from "@/components/Safety";
import { Faq } from "@/components/Faq";
import { DownloadCta } from "@/components/DownloadCta";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative overflow-x-clip">
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <Bento />
        <HowItWorks />
        <Screenshots />
        <Community />
        <Safety />
        <Faq />
        <DownloadCta />
      </main>
      <Footer />
    </div>
  );
}
